<SettingsLayout page='settings/general' label="General">
  <h1>General settings</h1>

  <h2>Media</h2>
  <form class="ui-settings">
    <label class="setting-group">
      <input type="checkbox" id="choice-never-mark-media-sensitive"
             bind:checked="$neverMarkMediaAsSensitive" on:change="onChange(event)">
      Show sensitive media by default
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-show-all-spoilers"
             bind:checked="$showAllSpoilers" on:change="onChange(event)">
      Expand content warnings by default
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-use-blurhash"
              bind:checked="$ignoreBlurhash" on:change="onChange(event)">
      Show a plain gray color for sensitive media
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-mark-media-sensitive"
             bind:checked="$markMediaAsSensitive" on:change="onChange(event)">
      Treat all media as sensitive
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-large-inline-media"
             bind:checked="$largeInlineMedia" on:change="onChange(event)">
      Show large inline images and videos
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-autoplay-gif"
             bind:checked="$autoplayGifs" on:change="onChange(event)">
      Autoplay animated GIFs
    </label>
  </form>

  <h2>UI</h2>
  <form class="ui-settings">
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-custom-scrollbars"
             bind:checked="$disableCustomScrollbars" on:change="onChange(event)">
      Disable custom scrollbars
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-infinite-scroll"
             bind:checked="$disableInfiniteScroll" on:change="onChange(event)">
      Disable
        <Tooltip
          text="infinite scroll"
          tooltipText="When infinite scroll is disabled, new toots will not automatically appear at the bottom or top of the timeline. Instead, buttons will allow you to load more content on demand."
        />
      
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-hide-cards"
             bind:checked="$hideCards" on:change="onChange(event)">
      Hide link preview cards
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-underline-links"
             bind:checked="$underlineLinks" on:change="onChange(event)">
      Underline links in toots and profiles
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-center-nav"
             bind:checked="$centerNav" on:change="onChange(event)">
      Center the navigation bar
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-bottom-nav"
             bind:checked="$bottomNav" on:change="onChange(event)">
      Place the navigation bar at the bottom of the screen
    </label>
  </form>

  <h2>Accessibility</h2>
  <form class="ui-settings">
    <label class="setting-group">
      <input type="checkbox" id="choice-reduce-motion"
             bind:checked="$reduceMotion" on:change="onChange(event)">
      Reduce motion in UI animations
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-always-show-focus-ring"
             bind:checked="$alwaysShowFocusRing" on:change="onChange(event)">
      Always show
      <Tooltip
        text="focus ring"
        tooltipText="The focus ring is the outline showing the currently focused element. By default, it's only shown when using the keyboard (not mouse or touch), but you may choose to always show it."
      />
      
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-tap-on-status"
             bind:checked="$disableTapOnStatus" on:change="onChange(event)">
      Disable tappable area on entire toot
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-omit-emoji-in-display-names"
             bind:checked="$omitEmojiInDisplayNames" on:change="onChange(event)">
      Remove emoji from user display names
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-long-aria-labels"
             bind:checked="$disableLongAriaLabels" on:change="onChange(event)">
      Use short article ARIA labels
    </label>
  </form>

  {#if $isUserLoggedIn }
    <h2>{themeTitle}</h2>
    <ThemeSettings instanceName={$currentInstance} />
  {/if}
</SettingsLayout>
<UISettingsStyles />
<script>
  import SettingsLayout from '../../_components/settings/SettingsLayout.html'
  import ThemeSettings from '../../_components/settings/instance/ThemeSettings.html'
  import { store } from '../../_store/store.js'
  import Tooltip from '../../_components/Tooltip.html'
  import UISettingsStyles from '../../_components/settings/UISettingsStyles.html'
  import { formatIntl } from '../../_utils/formatIntl.js'

  export default {
    components: {
      SettingsLayout,
      ThemeSettings,
      Tooltip,
      UISettingsStyles
    },
    methods: {
      onChange (event) {
        // these two are mutually exclusive
        const { markMediaAsSensitive, neverMarkMediaAsSensitive } = this.store.get()
        if (markMediaAsSensitive && neverMarkMediaAsSensitive) {
          if (event.target.id === 'choice-mark-media-sensitive') {
            this.store.set({ neverMarkMediaAsSensitive: false })
          } else {
            this.store.set({ markMediaAsSensitive: false })
          }
        }

        this.store.save()
      }
    },
    store: () => store,
    computed: {
      themeTitle: ({ $loggedInInstancesInOrder, $currentInstance }) => (
        $loggedInInstancesInOrder.length > 1
          ? formatIntl(["Theme for ",["instance"]], { instance: $currentInstance })
          : "Theme"
      )
    }
  }
</script>
